module.exports = __webpack_public_path__ + "img/logo-lan@2x.a866e1b9.png";